export default __webpack_public_path__ + "static/media/paris.9fa91f24.svg";